export default __webpack_public_path__ + "static/media/slider.40fb6324.svg";